import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_URL = `${BACKEND_URL}/api`;

// Create axios instance
const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('worldplate_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle auth errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('worldplate_token');
      localStorage.removeItem('worldplate_user');
      // Optionally redirect to login
    }
    return Promise.reject(error);
  }
);

// Auth API
export const authAPI = {
  register: (data) => api.post('/auth/register', data),
  login: (data) => api.post('/auth/login', data),
  getMe: () => api.get('/auth/me'),
};

// Recipes API
export const recipesAPI = {
  getAll: (params) => api.get('/recipes', { params }),
  getById: (id) => api.get(`/recipes/${id}`),
  create: (data) => api.post('/recipes', data),
  update: (id, data) => api.put(`/recipes/${id}`, data),
  delete: (id) => api.delete(`/recipes/${id}`),
  generate: (data) => api.post('/recipes/generate', data),
  getMyRecipes: () => api.get('/users/me/recipes'),
  getRecipeOfTheDay: () => api.get('/recipes/recipe-of-the-day'),
};

// Continents API
export const continentsAPI = {
  getAll: () => api.get('/continents'),
  getById: (id) => api.get(`/continents/${id}`),
  getCountryRecipes: (country, params) => api.get(`/countries/${encodeURIComponent(country)}/recipes`, { params }),
};

// Favorites API
export const favoritesAPI = {
  getAll: () => api.get('/favorites'),
  add: (recipeId) => api.post(`/favorites/${recipeId}`),
  remove: (recipeId) => api.delete(`/favorites/${recipeId}`),
  check: (recipeId) => api.get(`/favorites/check/${recipeId}`),
};

// Ratings API
export const ratingsAPI = {
  rate: (data) => api.post('/ratings', data),
  get: (recipeId) => api.get(`/ratings/${recipeId}`),
};

// Comments API
export const commentsAPI = {
  list: (recipeId) => api.get(`/recipes/${recipeId}/comments`),
  create: (recipeId, content) => api.post(`/recipes/${recipeId}/comments`, { content }),
  remove: (commentId) => api.delete(`/comments/${commentId}`),
};

// Preferences API
export const preferencesAPI = {
  get: () => api.get('/users/me/preferences'),
  update: (data) => api.put('/users/me/preferences', data),
};

// Stats API
export const statsAPI = {
  get: () => api.get('/stats'),
};

// Meal Planning API
export const mealPlanAPI = {
  getAll: () => api.get('/meal-plans'),
  getById: (id) => api.get(`/meal-plans/${id}`),
  create: (data) => api.post('/meal-plans', data),
  update: (id, data) => api.put(`/meal-plans/${id}`, data),
  delete: (id) => api.delete(`/meal-plans/${id}`),
  getShoppingList: (id) => api.get(`/meal-plans/${id}/shopping-list`),
};

export default api;
